import {
  Component,
  Input,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  OnInit,
} from '@angular/core';
import { CKEditor4 } from 'ckeditor4-angular';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'sd-ckeditor-control',
  templateUrl: './ckeditor-control.component.html',
  styleUrls: [
    '../../assets/css/label.scss',
    './ckeditor-control.component.css',
  ],
})
export class CkeditorControlComponent implements OnInit {
  @Input() label: string;
  @Input() disabled = false;
  @Input() required = false;
  @Input() set model(value: string) {
    this.cModel = value;
    this.ref.detectChanges();
  }
  @Input() set config(value: any) {
    this.cConfig = value;
    this.ref.detectChanges();
  }
  @Output() modelChange = new EventEmitter();
  // tslint:disable-next-line: no-output-native
  @Output() change = new EventEmitter();
  @Output() sdChange = new EventEmitter();
  cModel: string;
  cConfig: any;
  editorUrl = '../../assets/ckeditor/ckeditor.js';

  constructor(private ref: ChangeDetectorRef, private sanitizer: DomSanitizer) {

  }

  ngOnInit() {
  }

  onChange(value: any) {
    this.model = value;
    this.modelChange.emit(value);
    this.change.emit(value);
    this.sdChange.emit(value);
  }
}
